import React from 'react';
import {productTypesAPI} from "../api/api";
import ShowNotification from "../components/common/Notification/ShowNotification"; 

const SET_PRODUCT_TYPE_DATA = 'SET_PRODUCT_TYPE_DATA';
const UPDATE_PRODUCT_TYPE_DATA = 'UPDATE_PRODUCT_TYPE_DATA';
const ADD_PRODUCT_TYPE_DATA = 'ADD_PRODUCT_TYPE_DATA';

export const setProductType = (payload) => {
    return {
        type: SET_PRODUCT_TYPE_DATA,
        payload: payload
    }
}
export const updateProductType = (payload) => {
    return {
        type: UPDATE_PRODUCT_TYPE_DATA,
        payload: payload
    }
}
export const addProductType = (payload) => {
    return {
        type: ADD_PRODUCT_TYPE_DATA,
        payload: payload
    }
}


let initialState = {
    productTypes:[
        // {
        //     id: 1,
        //     name: 'group1',
        //     status: 1,
        //     building:{
        //         id: 1,
        //         name: "Bina111",
        //         status: 1
        //     }
        // }
    ],
    totalElements:31
}

let productTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRODUCT_TYPE_DATA:
            return {
                ...state,
                productTypes: action.payload.productTypes,
                // totalPages:action.payload.totalPages,
                totalElements:action.payload.totalElements,
                // size:action.payload.size
            }
        case UPDATE_PRODUCT_TYPE_DATA:
            return {
                ...state,
                ...action.payload
            }
        case ADD_PRODUCT_TYPE_DATA:
            return {
                ...state,
                ...action.payload
            }
        default :
            return state;
    }
}


export const getProductTypesTh = () => {
    return async (dispatch) => {
        let response = await productTypesAPI.getProductTypes();
        if (response) {
            dispatch(setProductType(response));
        } else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const addProductTypeTh = (productType) => {
    return async (dispatch) => {
        let response = await productTypesAPI.addProductTypes(productType);
        if (response.status===201) {
            ShowNotification("Succes","Device Products added successful", "success")
            dispatch(getProductTypesTh());
        } else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const updateProductTypeTh = (building,id,name,status) => {
    return async (dispatch) => {
        let response = await productTypesAPI.editProductTypes(building,id,name,status);
        if (response.status === 200) {
            // dispatch(updateProductType(response.data));
            ShowNotification("Succes","Device Products updated successful", "warning")

            dispatch(getProductTypesTh());
        } else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const deleteProductTypeTh = (locationId) => {
    return async (dispatch) => {
        let response = await productTypesAPI.deleteProductType(locationId );
        if (response.status === 200) {
            // dispatch(deleteBuildingData(response.content));
            ShowNotification("Succes","Device Products deleted successful", "danger")

            dispatch(getProductTypesTh());
        }else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export default productTypesReducer;
